import { useCallback, useEffect, useState } from "react";
import { shallow } from "zustand/shallow";
import { useHeaderStore } from "../../../../../store/header.store";

import style from "./ReportAbandonmentRate.module.css";
import styleForm from "../../../../../common/theme/styles/form.module.css";
import styleDataTable from "../../../../../common/UI/DataTable/dataTable.module.css";

import ProgressBar from "../../../../../common/UI/ProgressBar";
import useFormattedDate from "../../../../../common/hooks/useFormattedDate";

import ChartComponent from "../../../components/chart";
import InputSearch from "../../../../../common/UI/DataTable/inputSearch";
import { GetReportAbandonmentRateService } from "../../../services/Reports/getReportAbandonmentRate.service";
import { subDays } from "date-fns";
import { GetAnalyticsFiltersService } from "../../../../../common/services/getAnalyticsFilters.service";
import { GetSessionsWithPaginationService } from "../../../services/Reports/getSessionsWithPagination.service";
import DataTable from "../../../../../common/UI/DataTable/dataTable";
import AppInputSearchFilter from "../../../../../common/UI/Inputs/appInputSearchFilter";
import AppButton from "../../../../../common/UI/Buttons/AppButton"
import { GetInquiryDetailsBySessionService } from "../../../services/dashboard/getInquiryDetailsBySession.service"
import Modal from "../../../../../common/UI/Modal"
import { ConversationViewer } from "../../../components/ConversationViewer"
import { DataSelectDto } from "../../../../../common/dtos/general.dto";
import { GetWidgetsFilterWithPaginationService } from "../../../services/getWidgetsFilterWithPagination.service";
import ConatinerFilter from "../../../../../common/UI/DataTable/filterModal/containerFilter";
const getSessionsWithPaginationService = new GetSessionsWithPaginationService();


interface ChannelValues {
  channelName: string;
  values: number[];
}

interface InquiryAnalyticsResponse {
  dates: string[];
  channelValues: ChannelValues[];
}
interface ConversationMessage {
  inquiryId: string
  inquiryDate: string
  citizenId: string | null
  procedureTypeId: string | null
  question: string
  userInquiry: string
  inquiryForever: string
  inquiryDateTime: string
  inquiryGetDay: string
  inquiryStart: string
  inquiryGetMinute: string
  responseGeneratedDate: string
  responseGenerated: string
  userFeedback: string | null
}


export default function ReportAbandonmentRatePage() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );
  const hFormatDate = useFormattedDate();
  const today = new Date();

  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false);
  const [startDateAbandonmentRate, setStartDateAbandonmentRate] = useState<any>(subDays(today, 7));
  const [endDateAbandonmentRate, setEndDateAbandonmentRate] = useState<any>(today); // Inicia como null para evitar llamadas innecesarias
  const [responseDataGraphAbandonmentRate, setResponseDataGraphAbandonmentRate] = useState<InquiryAnalyticsResponse | null>(null);

  const [dataGraphSessionAbandonmentRate, setDataGraphAbandonmentRate] = useState<any[]>([]);
  const [dataGraphoptionsAbandonmentRate, setDataGraphoptionsAbandonmentRate] = useState<any>({});

  const [dataChannels, setDataChannels] = useState<any[]>([]);
  const [selectChannels, setSelectChannels] = useState<{ label: string; value: number }[]>([]);

  const [dataCountsTypes, setDataCountsTypes] = useState<any>({});
  const [selectCountsTypes, setSelectCountsTypes] = useState<{ label: string; value: string } | null>(null);
  const [isReloadData, setIsReloadData] = useState(false);

  // Estados para el modal de conversación
  const [conversationMessages, setConversationMessages] = useState<ConversationMessage[]>([])
  const [loadingConversation, setLoadingConversation] = useState(false)
  const [widgetFilter, setWidgetFilter] = useState<DataSelectDto>({
    label: '',
    value: ''
  });

  const serviceAllWidgets = useCallback(async (value: string) => {
    const response: any = await GetWidgetsFilterWithPaginationService({
      search: value,
      perPage: 100
    });
    return response.data.map((item: any) => ({
      label: item.name,
      value: item.widgetId,
    }));
  }, []);
  const getDataAbandonmentRate = useCallback(async () => {
    setLoading(true);
    const params: any = {
      startDate: startDateAbandonmentRate ? hFormatDate(startDateAbandonmentRate, "yyyy-MM-dd") : "",
      endDate: endDateAbandonmentRate ? hFormatDate(endDateAbandonmentRate, "yyyy-MM-dd") : "",
      channelIds: selectChannels.map((c: any) => c.value),
      sessionAbandonmentType: selectCountsTypes ? selectCountsTypes.value : "",
      widgetId: widgetFilter ? widgetFilter.value : "",
    };
    setIsReloadData(!isReloadData); // Recarga los datos después de la eliminación

    try {
      const response = await GetReportAbandonmentRateService(params);
      if (response) {
        setResponseDataGraphAbandonmentRate(response as InquiryAnalyticsResponse);
      } else {
        console.warn("No data received for session analytics.");
        setResponseDataGraphAbandonmentRate(null);
      }
    } catch (error) {
      console.error("Error fetching inquiry averages analytics:", error);
      setResponseDataGraphAbandonmentRate(null);
    } finally {
      setLoading(false);
    }
  }, [endDateAbandonmentRate, selectChannels, selectCountsTypes, widgetFilter]);


  const getAllAnalyticsFiltersChannels = async () => {
    const response: any = await GetAnalyticsFiltersService();
    setDataChannels(
      response.channels.map((item: any) => {
        return {
          label: item.channelName,
          value: item.channelId
        };
      })
    );
  };
  const getAllAnalyticsFiltersCountsTypes = async () => {
    const response: any = await GetAnalyticsFiltersService();
    setDataCountsTypes(
      response.statusAbandonment.map((item: any) => {

        return {
          label: item.label,
          value: item.value
        };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  useEffect(() => {
    if (startDateAbandonmentRate && endDateAbandonmentRate) {
      getDataAbandonmentRate();
      setIsReloadData(!isReloadData); // Recarga los datos después de la eliminación

    }
  }, [startDateAbandonmentRate, endDateAbandonmentRate, selectChannels, selectCountsTypes, widgetFilter]);
  useEffect(() => {
    headerStore.setModule("Reportes", "");
    headerStore.setModuleItem("Tasa abandono", "/admin/home");
    getAllAnalyticsFiltersChannels();
    getAllAnalyticsFiltersCountsTypes();

  }, []);

  // Helper para leer la var CSS
  const readOnSurface = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--color-on-surface-variant-main')
      .trim() || '#22356a';

  const [onSurface, setOnSurface] = useState(readOnSurface());

  useEffect(() => {
    const el = document.documentElement;
    const update = () => {
      const next = readOnSurface();
      setOnSurface(prev => (prev !== next ? next : prev));
    };
    const obs = new MutationObserver(update);
    // Detecta cambios de clase/data-theme/style en <html> (incluye cambios de CSS vars en :root)
    obs.observe(el, { attributes: true, attributeFilter: ['class', 'data-theme', 'style'] });
    update(); // primer chequeo
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!responseDataGraphAbandonmentRate) return;

    const formattedDates = responseDataGraphAbandonmentRate.dates.map((date: string) =>
      hFormatDate(date, "dd-MM-yyyy")
    );

    const channelData = responseDataGraphAbandonmentRate.channelValues.map((channel: ChannelValues) => ({
      name: channel.channelName,
      data: channel.values.map(value => Number(value) || 0),
    }));

    const numSeries = channelData.length;

    setDataGraphAbandonmentRate(channelData);

    setDataGraphoptionsAbandonmentRate({
      chart: {
        type: "area",
        height: 350,
        foreColor: onSurface, // <-- color global de textos
        zoom: { enabled: true, type: "x", autoScaleYaxis: true },
        toolbar: {
          show: true,
          tools: { download: true, selection: true, zoom: true, zoomin: true, zoomout: true, pan: true, reset: true },
          autoSelected: "zoom",
        },
      },
      theme: { palette: "palette8" },
      stroke: { curve: "straight", width: Array(numSeries).fill(3), dashArray: Array(numSeries).fill(0) },
      markers: { size: 5, hover: { sizeOffset: 3 } },
      dataLabels: {
        enabled: true,
      },
      xaxis: {
        categories: formattedDates,
        labels: { rotate: -60, style: { fontSize: "10px", colors: onSurface } }, // <-- labels usan "colors"
        title: { text: "Fechas", style: { fontSize: "12px", color: onSurface } },   // <-- title usa "color"
      },
      yaxis: {
        min: 0,
        decimalsInFloat: 0,
        labels: {
          formatter: (val?: number) => (val != null ? val.toFixed(0) : '0'),
          style: { fontSize: '12px', colors: onSurface }, // <-- labels usan "colors"
        },
        forceNiceScale: false,
        title: { text: "Total %", style: { fontSize: "12px", color: onSurface } },
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        labels: { colors: onSurface }, // <-- color del texto de leyenda
        formatter: (_: string, opts: { seriesIndex: number }) =>
          channelData[opts.seriesIndex]?.name ?? "Canal",
      },
      tooltip: { style: { fontSize: '12px', fontFamily: 'inherit' } },
      grid: { borderColor: onSurface.startsWith('#') ? `${onSurface}22` : undefined }, // sutil si es hex
    });
  }, [responseDataGraphAbandonmentRate, onSurface]); // <-- agrega onSurface




  const columns = [
    {
      header: "ID SESIÓN",
      field: "sessionId",
      render: (row: any) => {
        return (
          <div style={{ width: '200px' }}
          >{row.sessionId}</div>
        )
      }
    },
    {
      header: "FECHA INICIO",
      field: "",
      render: (row: any) => {
        return <>{row.startDate ? <div>{hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a")}</div> : ""}</>
      },
    },
    {
      header: "ESTADO",
      field: "status",
    },
    {
      header: "WIDGET ID",
      field: "widgetId",
    },
    {
      header: "CÓDIGO CIUDADANO",
      field: "",
      render: (row: any) => {
        return (
          <>
            {row.citizen ? (
              <div>{row.citizen.externalChannelId}</div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      header: "CANAL",
      field: "",
      render: (row: any) => {
        return (
          <>
            {row.citizen ? (
              <div>{row.citizen.communicationChannel?.channelName}</div>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      header: "OPCIONES",
      field: "",
      render: (row: any) => (
        <AppButton
          className={styleDataTable.buttom_option}
          variant="primary"
          iconName="edit"
          buttonText="Ver Conversación"
          onClick={() => handleView(row)}
        />
      ),
    },
  ]


  const handleView = async (row: any) => {
    // Validate that row has the required data
    if (!row || !row.sessionId) {
      console.error("Invalid session data:", row)
      return
    }

    setIsOpen(true)
    setLoadingConversation(true)
    setConversationMessages([])

    try {
      const params = {
        sessionId: row.sessionId,
      }
      const response: any = await GetInquiryDetailsBySessionService(params)
      // Handle the specific response structure from the API
      setConversationMessages(response)
    } catch (error) {
      setConversationMessages([])
    } finally {
      setLoadingConversation(false)
    }
  }
  const handleCloseModal = () => {
    setIsOpen(false)
    setConversationMessages([])
    setLoadingConversation(false)
  }
  return (
    <div className={style.Dashboard_page}>
      <h4 className={style.under__line}>
        <strong>Tasa de abandono:</strong>
      </h4>

      {/* Muestra el componente Loading siempre */}
      {loading && <ProgressBar />}

      <div className={style.containerGraph} style={{ marginTop: "0.5rem" }}>
        <div className={style.containerFilters}>
          <div >
            <AppInputSearchFilter
              name="channels"
              textLabel="Selecciona canal"
              data={dataChannels}
              selected={selectChannels}
              onSelect={setSelectChannels}
              multiple={true}
            />
          </div>
          <div style={{ maxWidth: 260 }}>

            <InputSearch
              classNameInput={styleForm.input__input}
              key={crypto.randomUUID()}
              textLabel="Selecciona estado"
              data={dataCountsTypes}
              selected={selectCountsTypes}
              onSelect={setSelectCountsTypes}
            />
          </div>
          <div
            className={style.container__select}
            style={{ minWidth: "280px" }}
          >
            <InputSearch
              key={crypto.randomUUID()}
              name="status"
              classNameInput={styleForm.input__input}
              textLabel="Selecciona widget"
              serviceCall={serviceAllWidgets}
              onSelect={(selected) => {
                setWidgetFilter(selected);
              }}
              selected={widgetFilter}
            />
          </div>
        </div>
        <ChartComponent
          key={`abandonment-${onSurface}`}   // <-- remonta cuando cambia el color del tema
          titleChart="Tasa de abandono"
          typeGraph="bar"
          dataDashboard={dataGraphSessionAbandonmentRate}
          dataOptions={dataGraphoptionsAbandonmentRate}
          onDateChange={(dateRange) => {
            if (dateRange) {
              setStartDateAbandonmentRate(dateRange[0]);
              setEndDateAbandonmentRate(dateRange[1]);
            }
          }}
        />
        <DataTable
          title="Listado de sesiones"
          columns={columns}
          service={getSessionsWithPaginationService}
          reloadData={isReloadData}
          // addButton={addButton}
          showSearch={false}
          params={{
            startDate: startDateAbandonmentRate ? hFormatDate(startDateAbandonmentRate, "yyyy-MM-dd") : "",
            endDate: endDateAbandonmentRate ? hFormatDate(endDateAbandonmentRate, "yyyy-MM-dd") : "",
            channelIds: selectChannels.map(c => c.value),
            status: selectCountsTypes ? selectCountsTypes.value : "",
            widgetId: widgetFilter ? widgetFilter.value : "",
          }}
          excelButton={{
            enabled: true,
            nameFile: `Lista de Sesiones`,
            getExcelData: (data) => {
              return data.map((row: any) => ({
                ID_SESIÓN: row.sessionId ?? "",
                FECHA_INICIO: row.startDate
                  ? hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a") // o new Date(row.startDate) si quieres celda de fecha real
                  : "",
                ESTADO: row.status ?? "",
                WIDGET_ID: row.widgetId ?? "",
                CÓDIGO_CIUDADANO: row.citizen?.externalChannelId ?? "",
                CANAL: row.citizen?.communicationChannel?.channelName ?? "",
              }));
            },
          }}
        >
          {''}
        </DataTable>
        <Modal
          title="Detalle de Conversación"
          isOpen={isOpen}
          onClose={handleCloseModal}
          size={{ width: "90%", maxWidth: "1400px", height: "80vh" }}
          loadingModal={false}
          footerContent={
            <div className={style.containerButtoms}>
              <button className={styleForm.buttomFooter + " " + styleForm.buttom_cancelar} onClick={handleCloseModal}>
                Cerrar
              </button>
            </div>
          }
        >
          {/* {selectedSessionData && ( */}
          <ConversationViewer
            messages={conversationMessages}
            loading={loadingConversation}
          />
          {/* )} */}
        </Modal>
      </div>
    </div>
  )
}
